import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

interface FrontShopOrderState extends ListState<any> {

}

class FrontOrderMutations extends ListMutations<any>{

}
class FrontShopOrder extends ListModule<FrontShopOrderState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
        ids: [],
        id: 0
    }
    actions = {
        async getAll(context: ActionContext<FrontShopOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontDistributionOrder/GetDistributionOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async PurchaseOperation(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontDistributionOrder/PurchaseOperation', payload.data);
            return rep.data.result;
        },
        async CancleOrder(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/FrontDistributionOrder/CancleOrder?id=' + payload.data.id);
        },
    };
    mutations = {
        setCurrentPage(state: FrontShopOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FrontShopOrderState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const frontShopOrder = new FrontShopOrder();
export default frontShopOrder;